export default {
    methods: {
        parseProfile (user) {
            if (user == null) return null;

            user.profile = {};
            if (user.withdrawCron)
            {
                user.profile.withdraw = this.fromCron(user.withdrawCron);
            }

            if (user.statementCron)
            {
                user.profile.statement = this.fromCron(user.statementCron);
            }

            return user;
        },
        fromCron (cron) {
            cron = cron.split(" ");
            let action = {};

            if (cron[2] != '*')
            {
                action.frequency = 'M';
                action.day = parseInt(cron[2]);
            }
            else if (cron[4] != '*')
            {
                action.frequency = 'W';
                action.day = parseInt(cron[4]);
            }
            else if (cron[2] == '*' && cron[3] == '*' && cron[4] == '*')
                action.frequency = 'D';

            return action;
        },
        toCron (action) {
            let day = action.day;
            let frequency = action.frequency;
            let cron = "";

            if (frequency === "M")
            {
                cron = "0 8 " + day + " * *";
            }
            else if (frequency === "W")
            {
                cron = "0 8 * * " + day;
            }
            else if (frequency === "D")
            {
                cron = "0 8 * * *";
            }
            return cron;
        },
        getProperty( propertyName, object ) {
            let parts = propertyName.split( "." ),
                length = parts.length,
                i,
                property = object || this;

            for ( i = 0; i < length; i++ ) {
                property = property[parts[i]];
            }

            return property;
        },
    }
}